import { updateSynchroDate } from "../parameter/parameterActions"
import { activityTypesFetchData } from "../activityTypes/activityTypesActions";
import { getAndStoreSubcontractors } from "../tiers/tiersActions";
import {
    loadProductCategories
} from '..//product/productActions'
import { getCurrentDate } from '../../time';
import {
    ERROR,
    SYNCHRO_GET_ACTIVE_USER,
    SYNCHRO_GET_ACTIVE_DAY,
    USER_SYNCHRO_CODE,
    ACTIVITY_TYPE_SYNCHRO_CODE,
    WORK_ORDERS_SYNCHRO_CODE,
    SUBCONTRACTORS_SYNCHRO_CODE,
    PRODUCT_CATEGORIES_SYNCHRO_CODE,
    WAITING_REQUESTS_SYNCHRO_CODE,
    DEFAULT_SYNCHRO_PERIOD_IN_MINUTES,
    SYNCHO_PERIODS_SYNCHRO_CODE,
    WHAT_S_UP_SYNCHRO_CODE,
    SITE_MONITORING_SYNCHRO_CODE,
    NB_EPI_TO_CHECK_SYNCHRO_CODE,
    NB_WAITING_INTERVIEWS_CODE
} from "./synchroConstants";
import { loadImputationsWorkOrders } from '../imputationInterventionRel/imputationInterventionRelActions'
import { synchronizeWorkOrders, setFilteredAndSortedInterventions, loadInterventionModel } from '../intervention/interventionActions';
import { setFilteredAndSortedSiteMonitorings, synchronizeSiteMonitorings } from '../siteMonitoring/siteMonitoringActions';
import {
    GET_PARAMETERS
} from '../parameter/parameterConstants';
import db from '../../db';
import { fetchWithTimeout } from '../../lib/fetch_wrapper';
import { throwErrorMessage } from '../../lib/error_helper';
import { getStateAccessor } from "../../lib/evaluateStringAsCodeHelper";
import { actualizeWaitingRequests } from "../serviceWorker/swActions";
import moment from "moment";
import { getActiveUser } from '../users/usersActions'
import { whatSUp } from "../news/newsActions";
import { actualizeNumberEPIToCheck } from "../epi/epiActions";
import { actualizeNbWaitingInterviews } from "../humanResources/humanResourcesActions";

export function getAllData() {
    return (dispatch) => {
        dispatch(activityTypesFetchData(true));
        dispatch(getAndStoreSubcontractors());
        dispatch(loadProductCategories());
    };
}

export async function getLocation(user, gps) {
    if (!gps) {
        console.error("Message temporaire: Erreur lors de la géolocalisation (gps désactivé ou utilisateur connecté introuvable)")
        return { type: ERROR, payload: "initial data error" };
    }
    const headers = new Headers({});

    return await fetchWithTimeout("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + gps.lat + "," + gps.lon + "&key=" + process.env.REACT_APP_GOOGLE_API_KEY, {
        method: 'GET',

        headers: headers,
        externalRequest: true,
    }).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    })
        .then((response) => response.json())
        .then((address) => {
            return {
                type: "GET_GEOCODIFICATION",
                payload: address.results.length > 0 ? address.results[0].formatted_address : gps
            };
        })
        .catch((e) => {
            console.error("Erreur lors de la géolocalisation" + e.toString());
            return { type: ERROR, info: 'getLocation', error: e };
        });
}

export function bgSyncApi(hideError = false) {
    return (dispatch) => {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        fetchWithTimeout('/bgSync', {
            method: 'GET',
            headers: headers,
            externalRequest: true
        }).catch((err) => {
            console.error("Erreur : synchroActions - bgSyncApi", err);
            if (hideError)
                return;
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la synchronisation !",
            }))
        });
    };
}

export function getDefaultSyncState() {
    return {
        activeUser: null,
        locationTitle: null,
        activeDay: null,
        reports: [],
        workOrders: [],
        activityTypes: [],
        timer_sync: null,
        blocTypes: [],
        loggedEmployee: null
    };
}

export function getSynchroActiveUser(currentState, hideError = false) {
    return (dispatch) => {
        dispatch(bgSyncApi(hideError));
        return db.User.limit(1).first().then(user => {
            if (user) {
                dispatch({ type: SYNCHRO_GET_ACTIVE_USER, payload: user })
                dispatch(getSynchroParameters(currentState, user.id));
            }
        }).catch((err) => {
            console.error("Erreur : synchroActions - getSynchroActiveUser", err)
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération de l'utilisateur actif !",
            }))
            dispatch({ type: ERROR, info: ("Récupération de l'utilisateur actif"), error: err });
        });
    };
}

export function getSynchroParameters(currentState, user_id) {
    return (dispatch) => {
        db.transaction("r?", db.Parameter, async () => {
            await db.Parameter.where("user_id").equals(user_id).toArray((data) => {
                if (data.length === 0) {
                    dispatch(setSynchroParameters(currentState, {
                        user_id: user_id,
                        sync: 15,
                        alarm: 15,
                        last_sync: null
                    }));
                } else {
                    dispatch({ type: GET_PARAMETERS, payload: data[0] })
                    dispatch(getSynchroActiveDay(currentState, user_id))
                }
            })
        }).catch((err) => {
            console.error("Erreur : synchroActions - getSynchroParameters")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération des paramètres de synchronisation !",
            }));
            dispatch({ type: ERROR, info: ("Récupération de synchronisation"), error: err });
        });
    }
}

export function setSynchroParameters(currentState, parameter) {
    return (dispatch) => {
        db.transaction("rw?", db.Parameter, async () => {
            db.Parameter.put(parameter).then(function () {
                dispatch(getSynchroActiveDay(currentState, parameter.user_id))
            }).catch((err) => {
                console.error("Erreur : synchroActions - setSynchroParameters")
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de l'ajout des paramètres de synchronisation !",
                }));
                dispatch({ type: ERROR, info: ("Ajout des paramètres"), error: err });
            });
        }).catch((err) => {
            console.error("Erreur : synchroActions - setSynchroParameters")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de l'ajout des paramètres de synchronisation !",
            }));
            dispatch({ type: ERROR, info: ("Récupération de synchronisation"), error: err });
        });
    };
}

export function getSynchroActiveDay(currentState, user_id) {
    return async (dispatch) => {
        await db.transaction("rw?", db.Day, db.User, async () => {
            db.Day.where({ user_id: user_id }).toArray((coll) => {
                let day = undefined;
                for (let i = 0; i < coll.length; i++) {
                    if (coll[i].active) {
                        day = coll[i];
                    }
                }

                // dispatch(activityTypesFetchData());
                // dispatch(getAndStoreSubcontractors());

                if (currentState.user !== null && currentState.user !== undefined) {
                    if (currentState.parameters !== undefined && currentState.parameters.last_sync !== null)
                        currentState.parameters.last_sync.setMinutes(currentState.parameters.last_sync.getMinutes() + currentState.parameters.sync)
                    dispatch(updateSynchroDate(user_id, getCurrentDate()))
                    dispatch(synchronizeWorkOrders(currentState.activeUser, currentState.blocTypes, getStateAccessor(currentState), currentState.history), () => {
                        dispatch(loadImputationsWorkOrders({ ...currentState.interventionsFilters }, true));
                        dispatch(setFilteredAndSortedInterventions({ ...currentState.interventionsFilters }))
                    })
                    // dispatch(activityTypesFetchData());
                    // dispatch(getAndStoreSubcontractors());
                }

                dispatch({ type: SYNCHRO_GET_ACTIVE_DAY, payload: day });
            })
        }).catch((err) => {
            console.error("Erreur : synchroActions - getSynchroActiveDay")
            dispatch(throwErrorMessage({
                errorObject: err,
                title: "Erreur",
                message: "Erreur lors de la récupération du jour actif de l'utilisateur " + user_id,
            }));
            dispatch({ type: ERROR, info: ("Erreur lors de la récupération du jour actif de l'utilisateur " + user_id), error: err });
        });
    }
}

export function initSynchronisations(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) {
    return (dispatch) => {
        console.info("Lancement des synchronisations périodiques")

        let promises = []
        getSynchroMapping().forEach((synchroType) => {
            promises.push(initializeSynchroInDb(synchroType))
        })

        Promise.all(promises).then(() => {
            dispatch(infiniteSynchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters))
        })
    }
}

/** Synchronisation récursive
 */
export function infiniteSynchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters) {
    return (dispatch) => {
        setInterval(() => {
            dispatch(synchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters))
        }, DEFAULT_SYNCHRO_PERIOD_IN_MINUTES * 60000)
    }
}

export function synchronization(state, stateAccessor, history, interventionsFilters, siteMonitoringsFilters, force = false) {
    return (dispatch) => {

        db.Synchronisations.toArray().then((allSynchro) => {
            allSynchro.forEach((synchro) => {

                if (!force && moment(synchro.nextSynchroDate, "DD/MM/YYYY HH:mm:ss") > moment())
                    return

                let currentSynchroType = getSynchroMapping().find((synchroType) => synchroType.code === synchro.typeCode)
                if (!currentSynchroType) {
                    console.error("Synchronisation en erreur car le type de synchro est introuvable");//Should never happen
                    return;
                }

                //Lancement de la requête de synchronisation
                currentSynchroType.synchroFunction(dispatch, history, { state, interventionsFilters, stateAccessor, siteMonitoringsFilters });
                let nextSynchroDate = moment().add(synchro.periodInMinutes, "minute").format("DD/MM/YYYY HH:mm:ss");

                //Mise à jour de la date de prochaine synchro
                db.Synchronisations.update(synchro.typeCode, { nextSynchroDate }).catch((err) => console.error(err))
            })
        })
    }
}

/** On initialise la table de synchronisations */
function initializeSynchroInDb(synchroType) {
    return new Promise((resolve, reject) => {
        db.transaction("rw", db.Synchronisations, () => {
            db.Synchronisations.get({ typeCode: synchroType.code }, (dbPeriod) => {
                if (dbPeriod) {
                    return resolve(dbPeriod);//Déjà initialisé
                }

                let synchroAsDbFormat = {
                    typeCode: synchroType.code,
                    periodInMinutes: DEFAULT_SYNCHRO_PERIOD_IN_MINUTES,
                    nextSynchroDate: moment().format("DD/MM/YYYY HH:mm:ss")//On veut que la synchro se lance une première fois dès le début
                }

                return resolve(db.Synchronisations.put(synchroAsDbFormat))
            }).catch((err) => {
                console.error(err);
                return reject(err)
            })
        })
    })
}

function getSynchroPeriods() {

    const headers = new Headers({ 'Content-Type': 'application/json' });
    fetchWithTimeout('/api/v1/synchro_periods', {
        method: 'GET',
        headers,
    }).then((response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }

        return response;
    }).then((response) => {
        return response.json()
    }).then((serverPeriods) => {
        serverPeriods.forEach((serverPeriod) => {
            db.Synchronisations.get({ typeCode: serverPeriod.code }).then((dbPeriod) => {
                if (dbPeriod) {
                    if (dbPeriod.periodInMinutes !== serverPeriod.periodInMinutes) {
                        dbPeriod.periodInMinutes = serverPeriod.periodInMinutes
                        db.Synchronisations.update(dbPeriod.typeCode, dbPeriod)
                    }

                    return;
                }

                let synchroAsDbFormat = {
                    typeCode: serverPeriod.code,
                    periodInMinutes: serverPeriod.periodInMinutes,
                    nextSynchroDate: moment().add(serverPeriod.periodInMinutes, "minute").format("DD/MM/YYYY HH:mm:ss")
                }

                db.Synchronisations.put(synchroAsDbFormat)
            })
        })
    }).catch((err) => {
        console.error("Erreur : synchroActions - getSynchroPeriods", err)
    })
}

function getSynchroMapping() {
    return [
        {
            code: WAITING_REQUESTS_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                //On actualise la liste des requêtes en attente
                //C'est asynchrone donc on attend avant de lancer l'actualisation
                //Pas moyen de savoir lorsque les requêtes ont été rejouées
                dispatch(actualizeWaitingRequests)
            }
        },
        {
            code: SYNCHO_PERIODS_SYNCHRO_CODE,
            synchroFunction: () => {
                getSynchroPeriods();
            }
        },
        {
            code: USER_SYNCHRO_CODE,
            synchroFunction: (dispatch, history, options) => {
                const { state } = options;
                dispatch(getSynchroActiveUser(state, true));
            }
        },
        {
            code: ACTIVITY_TYPE_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                dispatch(activityTypesFetchData(true));
            }
        },
        {
            code: PRODUCT_CATEGORIES_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                dispatch(loadProductCategories(true));
            }
        },
        {
            code: SUBCONTRACTORS_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                dispatch(getAndStoreSubcontractors(true));
            }
        },
        {
            code: WORK_ORDERS_SYNCHRO_CODE,
            synchroFunction: (dispatch, history, options) => {
                const { stateAccessor, interventionsFilters } = options;

                getActiveUser().then((activeUser) => {
                    dispatch(loadInterventionModel(true)).then(blocTypes => {
                        dispatch(synchronizeWorkOrders(activeUser, blocTypes, stateAccessor, history, () => {
                            if (interventionsFilters) {
                                dispatch(loadImputationsWorkOrders({ ...interventionsFilters }, true, true))
                                dispatch(setFilteredAndSortedInterventions({ ...interventionsFilters }, null, true))
                            }
                        }, true));
                    })
                })
            }
        },
        {
            code: WHAT_S_UP_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                dispatch(whatSUp())
            }
        },
        {
            code: SITE_MONITORING_SYNCHRO_CODE,
            synchroFunction: (dispatch, history, options) => {
                const { siteMonitoringsFilters } = options;
                getActiveUser().then((activeUser) => {
                    dispatch(synchronizeSiteMonitorings(activeUser, history, () => {
                        if (siteMonitoringsFilters) {
                            dispatch(setFilteredAndSortedSiteMonitorings({ ...siteMonitoringsFilters }, null, activeUser.id))
                        }
                    }, siteMonitoringsFilters, true));
                })
            }
        },
        {
            code: NB_EPI_TO_CHECK_SYNCHRO_CODE,
            synchroFunction: (dispatch) => {
                getActiveUser().then((activeUser) => {
                    dispatch(actualizeNumberEPIToCheck(activeUser));
                })
            }
        },
        {
            code: NB_WAITING_INTERVIEWS_CODE,
            synchroFunction: (dispatch) => {
                getActiveUser().then((activeUser) => {
                    dispatch(actualizeNbWaitingInterviews(activeUser));
                })
            }
        }
    ]
}
